<script setup>
import AuthenticationView from '@/views/AuthenticationView.vue'
import AppHeader from '@/components/app/AppHeader.vue'
import { useStore } from 'vuex'
import EventMultiSnackbars from '@/components/snackbar/EventMultiSnackbars.vue'
import CommentDrawer from '@/components/comment/CommentDrawer.vue'
import { computed, onMounted, provide, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHeightComposable } from '@/composables/useHeightComposable'

const store = useStore()
const route = useRoute()

const loggedIn = computed(() => store.state.authenticate.loggedIn)

const path = computed(() => route.fullPath)
watch(path, async () => {
  await setCommentTab()
})

const setCurrentTab = async (payload) => store.dispatch('comment/setCurrentTab', payload)

const setCommentTab = async () => {
  if (route.query.tab) {
    let tab = route.query.tab
    await setCurrentTab(route.meta?.tab[tab])
  } else if (route.meta.model) {
    await setCurrentTab({
      title: route.meta.title,
      model: route.meta.model
    })
  }
}

const appbar = ref(null)
const appHeaderHeight = ref(0)

provide('appHeaderHeight', appHeaderHeight)
const { mountObserver, observerWatcher } = useHeightComposable(appHeaderHeight, appbar)

watch(() => loggedIn.value, observerWatcher)

onMounted(async () => {
  await mountObserver()
  await setCommentTab()
})
</script>
<style lang="scss">
@use '/src/scss/variables.scss';
</style>

<template>
  <v-app>
    <AppHeader v-if="loggedIn" ref="appbar" />
    <v-main v-if="loggedIn">
      <CommentDrawer draggable />
      <router-view />
    </v-main>
    <AuthenticationView v-else />
    <EventMultiSnackbars />
  </v-app>
</template>
